export default "__VITE_ASSET__DQrL_QmH__"